import { render, staticRenderFns } from "./YpoEventsSortBy.vue?vue&type=template&id=2f24a66a&scoped=true&"
import script from "./YpoEventsSortBy.vue?vue&type=script&lang=js&"
export * from "./YpoEventsSortBy.vue?vue&type=script&lang=js&"
import style0 from "./YpoEventsSortBy.vue?vue&type=style&index=0&id=2f24a66a&lang=scss&scoped=true&"
import style1 from "./YpoEventsSortBy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24a66a",
  null
  
)

export default component.exports